import React from "react";
import Footer from "./footer/Footer";
import MobileFooter from "./footer/MobileFooter";
import NavBar from "./navbar/NavBar";

const Layout = ({ children }) => {
  return (
    //Folding the navbar component and footer component into layout component to be easily imported  to the various pages
    <div className="bg-main text-white">
      <NavBar />
      {children}
      <Footer />
      <MobileFooter />
    </div>
  );
};

export default Layout;
